import { useEffect, useState } from "react";
import polyline from "@mapbox/polyline";
import Map from "./Map";

export default function Home({ selectedAthlete, showEvent, showTraining }) {
  const [routes, setRoutes] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code) {
      // Validate OAuth state to prevent login-CSRF attacks
      const expectedState = sessionStorage.getItem("oauthState");
      sessionStorage.removeItem("oauthState");
      if (!expectedState || state !== expectedState) {
        console.error("OAuth state mismatch — possible CSRF attack, aborting.");
        window.history.replaceState({}, "", "/");
        return;
      }

      fetch(`${process.env.REACT_APP_BACKEND_URL}/strava/callback`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code })
      })
        .then(r => r.json())
        .then(() => {
          // Session cookie is now set — redirect to onboarding (no ID in URL)
          window.location.href = "/onboarding";
        });
    }


    fetch(`${process.env.REACT_APP_BACKEND_URL}/activities`)
      .then(r => r.json())
      .then(data => {
        console.log("Fetched activities:", data);
        const mapped = data.map(a => ({
          id: a.activityId,
          name: a.name,
          displayName: a.athleteId?.displayName || a.athleteId?.name || "Onbekende atleet",
          firstName: a.athleteId?.firstName || "Onbekende atleet",
          lastName: a.athleteId?.lastName || "Onbekende atleet",
          description: a.description,
          date: a.date,
          distance: a.distance,
          duration: a.moving_time,
          athlete: a.athleteId?.name || "Onbekende atleet",
          profilePhoto: a.athleteId?.profilePhoto || null,
          isTraining: a.isTraining, //type === "Workout",
          points: polyline.decode(a.summary_polyline)
        }));

        setRoutes(mapped);
      });
  }, []);

  return (
    <div>
      <h1>Hartekind routes</h1>
      <Map routes={routes}
        selectedAthlete={selectedAthlete}
        showEvent={showEvent}
        showTraining={showTraining} />
      {/* {routes && routes.length > 0 && <Map routes={routes} />}
      {(!routes || routes.length === 0) && <p>Er zijn nog geen routes beschikbaar.</p>} */}
    </div>
  );
}